import React from "react";
import { Link } from "react-router-dom";

import ResumeSummary from "./ResumeSummary";

const ResumeList = ({ resumes }) => {
  return (
    <div className="job-list section">
      {resumes &&
        resumes.map(resume => {
          return (
            <Link to={"/resume/" + resume.id}>
              <ResumeSummary resume={resume} key={resume.id} />
            </Link>
          );
        })}
    </div>
  );
};

export default ResumeList;
